import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Card, CardBody, Row, Col } from 'reactstrap'
import { SMSPackageActions } from "../../actions";
import { TableLoader } from '../../../components/Loaders';
import { SmsPackageForm } from './smsPackageForm';

class UpdateSmsPackage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: [],
            editorHtml: '',
            theme: 'snow',
            formData: {
                plan_title: '',
                features_list: '',
                permissions_list: [],
                subscription_type: '',
                chareslength: ''
            },
            errors: []
        }
        this.isLoad = false;
        this.getSMSPackage = this.getSMSPackage.bind(this);
    }

    componentDidMount() {
        this.getSMSPackage();
    }

   
    getSMSPackage() {
        const { dispatch } = this.props;
        const values = this.props.match.params.id
        let dataToSend = {
            id: values
        }
        dispatch(SMSPackageActions.getSMSPackage(dataToSend));
    }

    componentWillReceiveProps(props) {
        if (props.data) {
            this.setState({ formData: props.data })
        }
    }

    render() {
        
        const { loading } = this.props

        return (
            <div>
                <Row>
                    <Col xs="12">
                        <Card>
                            <CardBody>
                                <h3 className="text-center mb-4 mt-4"> SMS Package Detail </h3>
                                {loading ? <TableLoader /> :
                                    <SmsPackageForm/>
                                }
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }
}


function mapStateToProps(state) {
    const { loading, data } = state.getSMSPackage
    return {
        loading,
        data
    }
}
const connectedSmspackage = connect(mapStateToProps)(UpdateSmsPackage)
export { connectedSmspackage as UpdateSmsPackage }